import { hydrate } from "preact";
import { HOME_FLOW_VARIANT, pageFor } from "../pages.js";
import { followSurfaceColor } from "../shared/theme-color.js";
import { V2Site } from "./page.js";
import { PlannerV2Site } from "./planner-page.js";

const page = pageFor(document.body.dataset.page, location.pathname);

if (page.id === "cerimonialistas") {
  hydrate(<PlannerV2Site content={page.content} />, document.body);
} else if ("variant" in page) {
  hydrate(
    <V2Site content={page.content} locale={page.locale} variant={page.variant} />,
    document.body,
  );
} else if (page.id === "home") {
  hydrate(
    <V2Site content={page.content} locale={page.locale} variant={HOME_FLOW_VARIANT} />,
    document.body,
  );
}

followSurfaceColor();
